//imports
import {
    PM_USERS_FORCE_LOGOUT_OPEN_MODAL,
    PM_USERS_FORCE_LOGOUT_REQUEST,
    PM_USERS_FORCE_LOGOUT_RESULT,
    CLEAR_REDUX,
} from "Redux/actionTypes";

//initial values
const INIT_STATE = {
    openModal: false,
    user: null,
    loading: false,
    result: null
};

//change redux object
export default (state = INIT_STATE, action) => {
    switch (action.type) {

        case PM_USERS_FORCE_LOGOUT_OPEN_MODAL:
            return { ...state, openModal: action.payload.open, user: action.payload.user }

        case PM_USERS_FORCE_LOGOUT_REQUEST:
            return { ...state, loading: true }

        case PM_USERS_FORCE_LOGOUT_RESULT:
            return { ...state, loading: false, result: action.payload }

        case CLEAR_REDUX:
            return ["", "PMUSERS_FORCE_LOGOUT"].includes(action.payload.option)
                ? action.payload.parameters
                    ? { ...state, ...action.payload.parameters }
                    : { ...INIT_STATE }
                : { ...state };

        default:
            return state;
    }
};
